import { featureItems } from '@/mocks/siteData';

export default function FeatureCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why Thousands of Buyers Use Basetao Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            A structured spreadsheet system transforms the way you shop internationally. Here is why experienced buyers rely on this approach.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="group p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.iconClass} text-xl`}></i>
              </span>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}